import { getDNAEvents } from '../../libraries/api/domains'
import { getEventsForCameraUUID, parseEventPoints } from '../../libraries/api/events'
import { getRangeForWindow } from '../../libraries/util/timeline'

export const DnaModule = {
  namespaced: true,
  state: {
    cameraDetections: undefined,
    cameraAlerts: undefined,
    showDetections: false,
    window: {},
  },
  mutations: {
    addCameraAlerts (state, alerts) {
      state.cameraAlerts = alerts
    },
    addCameraDetections (state, detections) {
      if (state.cameraDetections) {
        const incoming = Object.assign({}, state.cameraDetections, detections)
        state.cameraDetections = incoming
      } else state.cameraDetections = detections
    },
    shouldShowDetections (state) {
      state.showDetections = !state.showDetections
    },
    setWindow (state, window) {
      state.window = window
    },
    clearDetections (state) {
      state.cameraDetections = undefined
    },
  },
  getters: {
    showDetections (state) {
      return state.showDetections
    },
    cameraEvents (state) {
      let events = state.cameraAlerts
      // console.log('RETURNING EVENTS GETTER')
      return events
    },
    cameraAlerts (state) {
      return state.cameraAlerts
    },
    cameraDetections (state, getters) {
      let detections = state.cameraDetections
      return detections
    },
    sortedDetectionBlocks (state) {
      if (state.cameraDetections) {
        const sorted = Object.keys(state.cameraDetections).sort((blockA, blockB) => {
          return blockA > blockB ? 1 : blockA < blockB ? -1 : 0
        })
        return sorted
      }
    },
    window (state) {
      return state.window
    },
    range (state) {
      if (state.window !== {}) {
        return getRangeForWindow(state.window.start, state.window.end)
      }
    },
  },
  actions: {
    getCameraAlerts ({ state, commit, rootState }, params) {
      const { domainUUID, cameraUUID, options } = params
      // options.limit = options.limit || 1500
      return getEventsForCameraUUID(domainUUID, cameraUUID, options)
        .then(res => res.data)
        .then(res => {
          const incoming = parseEventPoints(res.data)
          commit('addCameraAlerts', incoming)
        })
        .catch(error => console.error(`Failed to load timeline: `, error))
    },
    getCameraDetections ({ state, commit, rootState }, params) {
      const {
        dnaId,
        start,
        end,
      } = params
      const queryParams = `?start=${start}&end=${end}`
      return getDNAEvents(dnaId, queryParams).then(res => {
        commit('addCameraDetections', res.data.detections)
      })
    },
  },
}
